import { Location, VisitActivity } from '@inplay/models'; // Adjust according to your models location
import { isApiError } from '../utils/helper';
import { getEnvironmentVariable } from '../helper/config';
import { EnvVariables } from '../utils/helper.type';
import axiosClient from '../utils/apiClient';
import apiClient from '../utils/apiClient';
import { AxiosResponse } from 'axios';

export class VisitService {
  private baseApi: string;

  constructor() {
    const baseURL: string | undefined = axiosClient.defaults.baseURL;

    if (!baseURL) {
      throw new Error('baseURL is not defined in axiosClient.');
    }

    this.baseApi = baseURL;
  }

  public async getVisits(
    startTime: number,
    endTime: number,
    playerId: string,
    venueBranchIds: string[],
    location?: Location | undefined,
  ): Promise<VisitActivity[]> {
    try {
      console.log(`[VisitService][getVisitsSummary][ENTRY]`, {
        startTime,
        endTime,
        playerId,
        venueBranchIds,
        location,
      });

      const VisitApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_VISIT_API_RESOURCE,
      );
      const VisitApiEndpoint: string = `${this.baseApi}${VisitApiResource}`;

      const VisitApiResponse: AxiosResponse<VisitActivity[]> =
        await apiClient.get(VisitApiEndpoint, {
          params: {
            startTime,
            endTime,
            playerId,
            location,
            venueBranchIds: venueBranchIds[0],
          },
        });
      console.log(`[PlayerService][getVisitsSummary]`, {
        VisitApiResponse,
      });

      return VisitApiResponse.data;
    } catch (error: unknown) {
      console.error(`[PlayerService][getVisitsSummary][ERROR]`, {
        error,
      });

      if (isApiError(error)) {
        throw error;
      }

      return [];
    }
  }
}
